import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 34, testId }) => (
  <motion.div
    className={className}
    data-testid={testId}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", stagger = 0.12 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 28 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.8, ease } },
    }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for hero headings
export const MaskedLines = ({ lines, className = "", delay = 0.2 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease, delay: delay + i * 0.14 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
